import { Coffee, TreePalm, Flag, CalendarClock } from "../../../shared/icons";

// Compromissos (folga, férias, feriado, evento): só agenda, nunca entram em totais. Na
// tela usam ícone por tipo e cor neutra — nunca as cores de status financeiro.
export const EVENT_KIND_META = {
  folga: { label: "Folga", icon: Coffee },
  ferias: { label: "Férias", icon: TreePalm },
  feriado: { label: "Feriado", icon: Flag },
  evento: { label: "Evento", icon: CalendarClock },
};

export const EVENT_KIND_ORDER = ["folga", "ferias", "feriado", "evento"];

// Mesmo limite do backend (domain.MaxCalendarEventDays).
export const MAX_EVENT_DAYS = 60;

// Nome do compromisso na tela: o título, ou o tipo quando não há título.
export function eventLabel({ tipo, titulo }) {
  return titulo || EVENT_KIND_META[tipo]?.label || "Compromisso";
}

// "2026-11-10" -> "10/11"
function shortDate(iso) {
  const [, mes, dia] = (iso ?? "").split("-");
  return mes && dia ? `${dia}/${mes}` : iso;
}

// "em 10/11", "em 10/11 às 14:00" ou "de 10/11 a 20/11".
export function eventPeriod({ data_inicio: inicio, data_fim: fim, hora_inicio: hora }) {
  if (fim && fim !== inicio) return `de ${shortDate(inicio)} a ${shortDate(fim)}`;
  return `em ${shortDate(inicio)}${hora ? ` às ${hora}` : ""}`;
}

function isoDay(ano, mes, dia) {
  return `${ano}-${String(mes).padStart(2, "0")}-${String(dia).padStart(2, "0")}`;
}

// Primeiro e último dia do mês ("yyyy-MM-dd"), o intervalo pedido a GET /compromissos.
export function monthRange(ano, mes) {
  const ultimoDia = new Date(ano, mes, 0).getDate();
  return { de: isoDay(ano, mes, 1), ate: isoDay(ano, mes, ultimoDia) };
}

// Distribui os compromissos pelos dias do mês que cada um ocupa (férias de 25/11 a 05/12
// aparecem de 25 a 30 em novembro). As datas ISO comparam como texto.
export function groupEventsByDay(events, ano, mes) {
  const byDay = {};
  const ultimoDia = new Date(ano, mes, 0).getDate();
  for (let dia = 1; dia <= ultimoDia; dia += 1) {
    const iso = isoDay(ano, mes, dia);
    const doDia = events.filter((e) => e.data_inicio <= iso && e.data_fim >= iso);
    if (doDia.length > 0) byDay[dia] = doDia;
  }
  return byDay;
}
